import { Navigate, Outlet, useOutletContext } from "react-router-dom";
import { useLocale } from "../../../intl";
import { useCasaMapaAdminPortal } from "../../../hooks/useCasaMapaAdminPortal";
import CasaMapaAdminAnalyticsSubnav from "./CasaMapaAdminAnalyticsSubnav";

export default function CasaMapaAdminAnalyticsLayout() {
  const outletContext = useOutletContext() || {};
  const { permissions } = outletContext;
  const { clientViewId, dashboardPath } = useCasaMapaAdminPortal();
  const { t } = useLocale();

  if (!clientViewId) {
    return (
      <div className="panel-card">
        <h2>{t("realEstate.casaMapa.admin.errors.noViewTitle")}</h2>
        <p className="muted">{t("realEstate.casaMapa.admin.errors.noViewMessage")}</p>
      </div>
    );
  }

  if (!permissions?.viewAnalytics) {
    return <Navigate to={dashboardPath} replace />;
  }

  return (
    <div className="cm-admin-analytics">
      <header className="cm-admin-analytics__hero panel-card">
        <div className="cm-admin-analytics__hero-copy">
          <p className="cm-admin-analytics__eyebrow">{t("realEstate.casaMapa.admin.analytics.eyebrow")}</p>
          <h1 className="cm-admin-analytics__title">{t("realEstate.casaMapa.admin.analytics.title")}</h1>
          <p className="cm-admin-analytics__lead">{t("realEstate.casaMapa.admin.analytics.subtitle")}</p>
        </div>
        <CasaMapaAdminAnalyticsSubnav />
      </header>
      <Outlet context={outletContext} />
    </div>
  );
}
